import styled from "styled-components";

export const TitleStyled = styled.h1`
  font-size: 46px;
  margin-bottom: 50px;
`;
